import(/* webpackMode: "eager", webpackExports: ["BlocksRenderer"] */ "/root/repo/client/node_modules/@strapi/blocks-react-renderer/dist/BlocksRenderer.mjs");
;
import(/* webpackMode: "eager" */ "/root/repo/client/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/root/repo/client/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/root/repo/client/public/images/about/legal-betting-hero-img.jpg");
;
import(/* webpackMode: "eager" */ "/root/repo/client/src/app/(public)/(learn)/legal-state/[slug]/styles.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/repo/client/src/components/global/newsletter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/repo/client/src/components/global/state-selector.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/repo/client/src/components/global/top-sportsbooks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/repo/client/src/components/primitives/accordion.tsx");
;
import(/* webpackMode: "eager" */ "/root/repo/client/src/components/primitives/button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/repo/client/src/components/primitives/icon.tsx");
